<template>
  <div class="bind">
    <el-form class="select-panel-form" :inline="true" ref="form" :model="selectForm" label-width="80px">
      <div>
        <el-form-item>
          <el-select v-model="panelId" placeholder="请选择面板" size="mini" filterable clearable @change="changePanel" @clear="addPanel">
            <el-option v-for="item in panelOptions" :key="item.panelId" :label="item.panelName" :value="item.panelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" size="mini" class="button-width" @click="publish">保存</el-button></el-form-item>
        <el-form-item><el-button type="danger" size="mini" class="button-width" @click="deletePanel">删除</el-button></el-form-item>
      </div>
      <div>
          <el-form-item><el-input class="input-width-max" placeholder="请输入模板名称" size="mini" v-model="realPanelName" ></el-input></el-form-item>
      </div>
    </el-form>
    <div class="panel-form">
      <el-form v-for="(form, index) in paramDTOS" :key="index" :inline="true" ref="form" :model="form" label-width="80px">
        <div class="block-bind">
          <div class="row">
            <el-form-item>
              <el-select disabled :value="form.type" placeholder="请选择母版" size="mini" class="select-width" @change="res => changeMother(res, index)">
                <el-option v-for="item in motherboadrOptions" :key="item.type" :label="item.label" :value="item.type"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="s1" v-if="form.type == 1">
            <div class="row">
              <div v-for="(item, formIndex) in form.formObjects" :key="formIndex">
                <el-form-item><el-input class="input-width-r" placeholder="表单字段中文名称" size="mini" v-model="item.name" disabled></el-input></el-form-item>
                <el-form-item><el-input class="input-width-r" placeholder="占位编号" size="mini" v-model="item.placeholder" disabled></el-input></el-form-item>
                <el-form-item><el-input class="input-width-r" placeholder="单位" size="mini" v-model="item.unit" disabled></el-input></el-form-item>
                <el-form-item>
                  <el-autocomplete
                    class="input-width-r"
                    size="mini"
                    clearable
                    v-model="listIndex[item.placeholder]"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="搜索测点"
                    @select="res=>handleSelect(res,item.placeholder)"
                  >
                    <template slot-scope="{ item }">
                      <el-tooltip effect="dark" :content="item.name" placement="right-start">
                        <div class="query-item-text">{{ item.name }}</div>
                      </el-tooltip>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item><el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button></el-form-item>
                <div class="row" v-if="item.hasOwnProperty('statusMap')">
                  <div class="title">数字量状态列表</div>
                  <div>
                    <el-table :data="item.statusMap" style="width: 100%">
                      <el-table-column fixed prop="number" label="信息量数字">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.number" size="mini" placeholder="请输入信息量"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="显示中文">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" size="mini" placeholder="请输入中文名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="color" label="颜色">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.color" size="mini" placeholder="请输入颜色值"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                          <el-button v-if="scope.$index > 0" type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="s2" v-if="form.type == 2">
            <div class="row" v-for="(item, formIndex) in form.listObjects" :key="formIndex">
              <div>
                <el-form-item><el-input v-model="headerTitle" placeholder="列头名称" size="mini" class="input-width" disabled></el-input></el-form-item>
                <el-form-item v-for="(title, colIndex) in item.titles" :key="colIndex">
                  <el-input v-model="item.titles[colIndex]" placeholder="列头名称" size="mini" class="input-width" disabled></el-input>
                </el-form-item>
              </div>
              <div v-for="(row, rowIndex) in item.columns" :key="rowIndex">
                <el-form-item><el-input disabled placeholder="行头名称" size="mini" class="input-width" v-model="item.columns[rowIndex].key"></el-input></el-form-item>
                <el-form-item v-for="(bit, bitIndex) in item.titles" :key="bitIndex">
                  <!-- <div><el-input placeholder="占位编号" v-model="item.columns[rowIndex]['val'][bitIndex]" size="mini" class="input-width" disabled></el-input></div> -->
                  <div>
                    <el-autocomplete
                      class="input-width"
                      size="mini"
                      v-model="listIndex[item.columns[rowIndex]['val'][bitIndex]]"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="搜索测点"
                    >
                      <template slot-scope="{ item }">
                        <el-tooltip effect="dark" :content="item.name" placement="right-start">
                          <div class="query-item-text">{{ item.name }}</div>
                        </el-tooltip>
                      </template>
                    </el-autocomplete>
                  </div>
                </el-form-item>
                <el-form-item></el-form-item>
              </div>
            </div>
          </div>
          <div class="s3" v-if="form.type == 3">
            <div class="row">
              <div v-for="(item, formIndex) in form.picObjects" :key="formIndex">
                <el-form-item><el-input class="input-width-r" placeholder="表单字段中文名称" size="mini" v-model="item.name" disabled></el-input></el-form-item>
                <el-form-item><el-input class="input-width-r" placeholder="占位编号" size="mini" v-model="item.placeholder" disabled></el-input></el-form-item>
                <el-form-item><el-input class="input-width-r" placeholder="单位" size="mini" v-model="item.unit" disabled></el-input></el-form-item>
                <el-form-item>
                  <el-autocomplete
                    class="input-width-r"
                    size="mini"
                    v-model="listIndex[item.placeholder]"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="搜索测点"
                    @select="res=>handleSelect(res,item.placeholder)"
                  >
                    <template slot-scope="{ item }">
                      <el-tooltip effect="dark" :content="item.name" placement="right-start">
                        <div class="query-item-text">{{ item.name }}</div>
                      </el-tooltip>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item><el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button></el-form-item>
                <div class="row" v-if="item.hasOwnProperty('statusMap')">
                  <div class="title">数字量状态列表</div>
                  <div>
                    <el-table :data="item.statusMap" style="width: 100%">
                      <el-table-column fixed prop="number" label="信息量数字">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.number" size="mini" placeholder="请输入信息量"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="显示中文">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" size="mini" placeholder="请输入中文名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="color" label="颜色">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.color" size="mini" placeholder="请输入颜色值"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                          <el-button v-if="scope.$index > 0" type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/utils/auth';
import API from '@/api/glconfig';
export default {
  components: {},
  props: {
    projectId: {
      type: String
    },
    combineId: {
      type: [String, Number]
    },
    panelInfo: {
      type: Object
    },
    idx:{
      type:Number
    }
  },
  data() {
    return {
      panelId: '',
      panelDataId: 0,
      objects: {},
      restaurants: [],
      selectForm: {},
      panelName: '',
      realPanelName:'',//新增子描述
      paramDTOS: [{ type: 1 }, { type: 2 }, { type: 3 }],
      panelOptions: [],
      motherboadrOptions: [{ type: 1, label: '表单母版' }, { type: 2, label: '列表母版' }, { type: 3, label: '图标母版' }],
      activeName: 'first',
      headerTitle: '列头名称',
      projectOptions: [],
      listIndex: {}
    };
  },
  watch: {
    panelInfo: {
      handler(newVal, oldVal) {
        if(newVal.panelId){
          this.panelId = newVal.panelId;
          this.panelDataId = newVal.panelDataId;
          this.realPanelName = newVal.panelName;
          this.objects = newVal.params;
          this.listIndex = {};
          newVal.params.forEach((item,index)=>{
            this.listIndex[index] = item.key;
          })
          this.listIndex = JSON.parse(JSON.stringify(this.listIndex));
          this.searchSimulationPanelTemplateById(newVal.panelId);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //初始化
    init() {
      this.paramDTOS = [{}];
      this.searchAllSimulationPanelTemplateById();
    },
    //绑点1
    querySearchAsync(queryString, cb) {
      let params = { projectId: this.projectId, query: queryString };
      if (queryString) {
        API.fuzzySearchFields(params).then(res => {
          if (res.data.code == 200) {
            var restaurants = res.data.data;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
            cb(results);
          }
        });
      }
    },
    createStateFilter(queryString) {
      return state => {
        let res = state.value.toLowerCase().indexOf(queryString.toLowerCase()) === -1;
        return res == -1 ? false : true;
      };
    },
    //变更数据
    handleSelect(res,index) {
      // this.listIndex[index] = res.value;
      // this.listIndex = JSON.parse(JSON.stringify(this.listIndex));
    },
    //清除数据
    clears(index){
      // this.listIndex[index]='';
      // this.listIndex = JSON.parse(JSON.stringify(this.listIndex));
    },
    //根据id获取面板模板
    searchSimulationPanelTemplateById(id) {
      API.searchSimulationPanelTemplateById({ id: id }).then(res => {
        this.panelName = res.data.data.panelName;
        this.paramDTOS = [res.data.data];
        let tmpItem = [];
        this.paramDTOS.forEach((item, key) => {
          var it = { ...item };
          if (item.formObjects) {
            item.formObjects.forEach((item1, index) => {
              for(let i in this.objects){
                if(i==item1.placeholder){
                  if(this.objects[i].hasOwnProperty('statusMap')){
                    item1.statusMap = this.objects[i].statusMap;
                  }
                  break;
                }
              }
              if (item1.statusMap) {
                let statusMap = [];
                for (var key in item1.statusMap) {
                  item1.statusMap[key].number = key;
                  statusMap.push(item1.statusMap[key]);
                }
                it.formObjects[index].statusMap = statusMap;
              }
            });
            tmpItem.push({ type: 1, formObjects: it.formObjects });
          }
          if (item.listObjects) {
            item.listObjects.forEach((item, index) => {
              //解析columns
              if (item.columns) {
                let statusMap = [];
                for (var key in item.columns) {
                  statusMap.push({ key: key, val: item.columns[key] });
                }
                it.listObjects[index].columns = statusMap;
                //排序
                if(it.listObjects[index].columns.length>1){
                  let tobj = []
                  it.listObjects[index].columns.sort(function(a,b){
                    return a.val[0]-b.val[0]
                  })
                }
              }
            });
            tmpItem.push({ type: 2, listObjects: it.listObjects });
          }
          if (item.picObjects) {
            item.picObjects.forEach((item2, index2) => {
              for(let i in this.objects){
                if(i==item2.placeholder){
                  if(this.objects[i].hasOwnProperty('statusMap')){
                    item2.statusMap = this.objects[i].statusMap;
                  }
                  break;
                }
              }
              if (item2.statusMap) {
                let statusMap = [];
                for (var key in item2.statusMap) {
                  item2.statusMap[key].number = key;
                  statusMap.push(item2.statusMap[key]);
                }
                it.picObjects[index2].statusMap = statusMap;
              }
            });
            tmpItem.push({ type: 3, picObjects: it.picObjects });
          }
        });
        this.paramDTOS = JSON.parse(JSON.stringify(tmpItem));
        this.sort();
      });
    },
    //切换面板
    changePanel() {
      API.searchAllSimulationPanelTemplateById().then(res => {
        if (res.data.code == 200) {
          this.panelOptions = res.data.data;
          this.panelOptions.forEach(item => {
            if (item.panelId == this.panelId) {
              this.panelName = item.panelName;
              this.paramDTOS = item.paramDTOS;
            }
          });
          let tmpItem = [];
          this.paramDTOS.forEach((item, key) => {
            var it = { ...item };
            if (item.formObjects) {
              it.type = 1;
              item.formObjects.forEach((item1, index) => {
                if (item1.statusMap) {
                  let statusMap = [];
                  for (var key in item1.statusMap) {
                    item1.statusMap[key].number = key;
                    statusMap.push(item1.statusMap[key]);
                  }
                  it.formObjects[index].statusMap = statusMap;
                }
              });
            }
            if (item.listObjects) {
              it.type = 2;
              item.listObjects.forEach((item, index) => {
                //解析columns
                if (item.columns) {
                  let statusMap = [];
                  for (var key in item.columns) {
                    statusMap.push({ key: key, val: item.columns[key] });
                  }
                  it.listObjects[index].columns = statusMap;
                }
              });
            }
            if (item.picObjects) {
              it.type = 3;
              item.picObjects.forEach((item2, index2) => {
                if (item2.statusMap) {
                  let statusMap = [];
                  for (var key in item2.statusMap) {
                    item2.statusMap[key].number = key;
                    statusMap.push(item2.statusMap[key]);
                  }
                  it.picObjects[index2].statusMap = statusMap;
                }
              });
            }
            tmpItem.push(it);
          });
          this.paramDTOS = tmpItem;
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
          this.sort();
        }
      });
    },
    //新增母版
    addMotherBoadr(index) {
      if (this.paramDTOS.length > 2) {
        this.$message.warning('每个面板最多支持3个母版！');
        return false;
      }
      if (!this.paramDTOS[index].type) {
        this.$message.warning('请选择母版类型！');
        return false;
      }
      this.paramDTOS.push({});
    },
    //删除模板
    deleteMotherBoadr(index) {
      if (this.paramDTOS[index].type) {
        this.$confirm('确认要删除此母版吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.paramDTOS.splice(index, 1);
        });
      } else {
        this.paramDTOS.splice(index, 1);
      }
    },
    //切换母版前的操作
    changeMotherBefore($even, index) {
      if ($even == true) {
        let type = this.paramDTOS[index].type;
      }
    },
    //切换母版
    changeMother(res, index) {
      let type = res;
      this.$confirm('此操作会清空当前数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.paramDTOS[index].type = type;
          if (type == 1) {
            this.paramDTOS[index].formObjects = [{ name: '', placeholder: '', unit: '' }];
          } else if (type == 2) {
            this.paramDTOS[index].listObjects = [{ columns: [{ key: '', val: [] }], titles: [] }];
          } else if (type == 3) {
            this.paramDTOS[index].picObjects = [{ name: '', placeholder: '', unit: '' }];
          }
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        })
        .catch(() => {});
    },
    //增加表单字段中文名称
    addFormData(index) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects.push({ name: '', placeholder: '', unit: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      if (type == 3) {
        this.paramDTOS[index].picObjects.push({ name: '', placeholder: '', unit: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      this.sort();
    },
    //删除表单字段中文名称
    delFormData(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.$confirm('确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.paramDTOS[index].formObjects.splice(formIndex, 1);
        });
      }
    },
    //增加数字量状态
    addStatusMap(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        if (this.paramDTOS[index].formObjects[formIndex].statusMap && this.paramDTOS[index].formObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].formObjects[formIndex].statusMap = [{ number: '', name: '', color: '' }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      } else if (type == 3) {
        if (this.paramDTOS[index].picObjects[formIndex].statusMap && this.paramDTOS[index].picObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].picObjects[formIndex].statusMap = [{ number: '', name: '', color: '' }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      }
    },
    //添加一行表记录
    addTableData(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects[formIndex].statusMap.push({ number: '', name: '', color: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      } else if (type == 3) {
        this.paramDTOS[index].picObjects[formIndex].statusMap.push({ number: '', name: '', color: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
    },
    //删除一行表记录
    delTableData(index, formIndex, rowIndex) {
      let type = this.paramDTOS[index].type;
      this.$confirm('确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == 1) {
          this.paramDTOS[index].formObjects[formIndex].statusMap.splice(rowIndex, 1);
        } else if (type == 3) {
          this.paramDTOS[index].picObjects[formIndex].statusMap.splice(rowIndex, 1);
        }
      });
    },
    //新增面板
    addPanel() {
      if (this.panelId || this.panelName) {
        this.$confirm('是否保存当前编辑面板?', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '不保存',
          type: 'warning'
        })
          .then(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          })
          .catch(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          });
      } else {
        this.panelId = '';
        this.panelName = '';
        this.paramDTOS = [{}];
      }
    },
    /* 列表母版*/
    //加列
    addCol(index, formIndex) {
      this.paramDTOS[index].listObjects[formIndex].titles.push('');
      this.sort();
    },
    //删列
    delCol(index, formIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].titles.length - 1;
      this.paramDTOS[index].listObjects[formIndex].titles.splice(pos, 1);
    },
    //加行
    addRow(index, formIndex) {
      let val = [];
      let titles = this.paramDTOS[index].listObjects[formIndex].titles;
      titles.forEach(item => {
        val.push('');
      });
      this.paramDTOS[index].listObjects[formIndex].columns.push({ key: '', val: val });
      this.sort();
    },
    //删行
    delRow(index, formIndex, rowIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].columns.length - 1;
      if (pos > 0) {
        this.paramDTOS[index].listObjects[formIndex].columns.splice(rowIndex, 1);
      }
    },
    //加组
    addGroup(index, formIndex) {
      this.paramDTOS[index].listObjects.push({
        columns: [{ key: '', val: [] }],
        titles: []
      });
    },
    //反选表单
    setForm() {
      this.paramDTOS.map(item => {
        let key = '';
        if (item.hasOwnProperty('formObjects')) {
          key = 'formObjects';
        }
        if (item.hasOwnProperty('picObjects')) {
          key = 'picObjects';
        }
        if (item.hasOwnProperty('listObjects')) {
          key = 'listObjects';
        }
        item[key].map(item1 => {
          if (item1.hasOwnProperty('placeholder')) {
            item1.test = this.objects[item1.placeholder].value;
          }
          if (item1.hasOwnProperty('statusMap') && item1.statusMap != null) {
            item1.statusMap.map(item2 => {
              item1.test = this.objects[item2.number].value;
            });
          }
          if (item1.hasOwnProperty('columns')) {
            item1.columns.map(item3 => {
              let v = [];
              for (var key in item3.val) {
                // v.push(number);
                // number++;
              }
              // item3.val = v;
            });
          }
        });
      });
    },
    //数字排序
    sort() {
      let number = 0;
      this.paramDTOS.map(item => {
        let key = '';
        if (item.hasOwnProperty('formObjects')) {
          key = 'formObjects';
        }
        if (item.hasOwnProperty('picObjects')) {
          key = 'picObjects';
        }
        if (item.hasOwnProperty('listObjects')) {
          key = 'listObjects';
        }
        item[key].map(item1 => {
          if (item1.hasOwnProperty('placeholder')) {
            item1.placeholder = number;
            number++;
          }
          if (item1.hasOwnProperty('statusMap') && item1.statusMap != null) {
            item1.statusMap.map(item2 => {
             // item2.number = number;
              // number++;
            });
          }
          if (item1.hasOwnProperty('columns')) {
            item1.columns.map(item3 => {
              let v = [];
              for (var key in item3.val) {
                v.push(number);
                number++;
              }
              item3.val = v;
            });
          }
        });
      });
    },
    //获取statusmap结合
    getStatusMap(dtos) {
      let res = [];
      let objects = [];
      for (let i in this.listIndex) {
        objects.push({ index: i, key: this.listIndex[i] });
      }
      objects.map(e => {
        dtos.forEach(item => {
          if (item.type == 1) {
            item.formObjects.forEach(it => {
              let realItem = {};
              if (it.hasOwnProperty('statusMap')) {
                let tmp = {};
                let key = '';
                it.statusMap.forEach(i => {
                  key = i.number.toString();
                  tmp[key] = { name: i.name, color: i.color };
                });
                if (e.index == it.placeholder) {
                  e.statusMap = tmp;
                }
              }
            });
          }
          if (item.type == 3) {
            item.picObjects.forEach(it => {
              let realItem = {};
              if (it.statusMap == null) {
                delete it.statusMap;
              }
              if (it.hasOwnProperty('statusMap')) {
                let tmp3 = {};
                let key = '';
                it.statusMap.forEach(i => {
                  key = i.number.toString();
                  tmp3[key] = { name: i.name, color: i.color };
                });
                if (e.index == it.placeholder) {
                  e.statusMap = tmp3;
                }
              }
            });
          }
        });
      });

      return objects;
    },
    //发布面板
    publish() {
      let params = {};
      params.panelId = this.panelId ? this.panelId : 0;
      params.panelDataId = this.panelDataId ? this.panelDataId : 0;
      params.combineId = this.combineId;
      params.projectId = this.projectId;
      params.panelName = this.realPanelName;
      params.objects = [];
      let dtos = JSON.parse(JSON.stringify(this.paramDTOS));
      let statusMap = this.getStatusMap(dtos);
      params.objects = statusMap;

      API.saveOrUpdateSimulationPanelData(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.$emit('finish',params)
        }
      });
    },
    //删除面板
    deletePanel(){
      this.$emit('delete',{index:this.idx,panelDataId:this.panelDataId});
    },
    //获取全部模板
    searchAllSimulationPanelTemplateById() {
      API.searchAllSimulationPanelTemplateById().then(res => {
        if (res.data.code == 200) {
          this.panelOptions = res.data.data;
        }
      });
    },
    handleClick(e) {}
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped="scoped">
.bind {
  margin-right: 10px;
  .select-panel-form {
    .button-width {
      width: 90px;
    }
  }
  .input-width-r {
    width: 85px;
  }
  .input-width-max{
    width:374px;
  }
  .panel-form {
    .select-width {
      width: 650px;
    }
    .input-width {
      width: 80px;
    }
    .block-bind {
      border: 1px solid #dddeee;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;
      .title {
        margin: 10px 0px;
        font-weight: bold;
      }
      .row {
        margin: 5px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/template/components/bind.vue